module.exports = __webpack_public_path__ + "static/GorditaBlack-76e64de57ad8bbc347ae5681d6291e47.otf";